import Action from 'actions';
import {PositionInLineup} from 'helpers/lineup-helper';
import Const from 'constants';
import BaseLineup from 'services/sports/default/base-lineup';

export default class LineupClassic extends BaseLineup {
    getValidationRules({defaultValue = {}, ...rest}) {
        const {stacks, playersData, playersLock} = Action.getState();

        const nhlNameStack = {
            stacks: {},
            extraValidationRules: {},
        };

        if (stacks.nhlName.useStack) {
            const {players} = playersData;
            Object.keys(stacks.nhlName.groups).map((groupNumber) => {
                const stack = stacks.nhlName.groups[groupNumber];
                stack.items.map((item) => {
                    const updatedPlayers = item.players.map((player) => {
                        return {
                            ...player,
                            ...players.getPlayer(player.playerId),
                        };
                    });
                    item.players = [...updatedPlayers];
                });
            });

            if (stacks.nhlName.isDoubleStackMode) {
                nhlNameStack.stacks = {...stacks.nhlName.groups};
            } else {
                nhlNameStack.stacks[Const.NHL_NAME_STACK_FIRST_GROUP] = {
                    ...stacks.nhlName.groups[Const.NHL_NAME_STACK_FIRST_GROUP],
                };
            }
        }

        const nonControlledStack = {
            stacks: {},
        };

        if (stacks.nonControlled.useStack) {
            nonControlledStack.stacks = {...stacks.nonControlled.list};
        }

        return {
            nhlNameStack,
            nonControlledStack,
            lockedPlayers: playersLock.getMergedLockedPlayerIds(),
        };
    }

    setPlayersByColumns({incomingValues: {team}}) {
        const {sportConfig} = Action.getState();
        const positionsOrder = sportConfig.getConfigProp('positionsOrder', {});

        const players = PositionInLineup.set.inDependenceOnOrder({team, positionsOrder});

        return this.exec('forcePlayerToFlexPosition', {
            lineupPlayers: players,
            flexPositionNames: [Const.POSITION_UTIL],
        });
    }
}
